export function DocxReportPlaceholder() {
    return `return async function convertToDocx(report, audit, generateUtils, reportParams) {

    const { Document, Paragraph, TextRun, HeadingLevel } = generateUtils.Docx;

    const doc = new Document({
        sections: [
            {
                children: [
                    new Paragraph({
                        text: audit.title,
                        heading: HeadingLevel.HEADING_1
                    })
                ]
            }
        ]
    });

    return {
        fileName: audit.title + '.docx',
        doc
    };
};`;
}
